import React, { useEffect, useState } from 'react';
import {
  IHealthPlanMaster,
  IPayerAddressItem,
} from '../Infrastructure/Interfaces';
import useTable from '../TablePagination/UseTable';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Input,
  Flex,
  useDisclosure,
  Tooltip,
  IconButton,
  Button,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  Spacer,
  Select,
} from '@chakra-ui/react';
import TablePagination from '../TablePagination/TablePagination';
import { BsPencilSquare } from 'react-icons/bs';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch } from 'react-redux';
import { FaMapSigns } from 'react-icons/fa';
import PayerAddressModalPopup from './PayerAddressModalPopup';
import { setPayerAddressItem } from '../Store/PayerAddressReducer';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { fetchPayerAddressList } from '../Store/GetDropDownsValuesReducer';
import { ImBin } from 'react-icons/im';

interface Props {
  PayerAddressList: IPayerAddressItem[];
}

function PayerAddressPg({ PayerAddressList }: Props) {
  const [value, setValue] = useState('');
  const [TableFilter, setTableFilter] = useState(PayerAddressList);
  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    value.length > 0 ? TableFilter : PayerAddressList,
    currentPage,
    claimsPerPage
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch<AppDispatch>();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  const [toBeDeletedItem, setToBeDeleteItem] = useState<IPayerAddressItem>();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();
  const toast = useToast();
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const cancelRef = React.useRef(null);
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);

  function deleteItemDialog(item: IPayerAddressItem) {
    setToBeDeleteItem(item);
    onDeleteModalOpen();
  }

  async function deleteItem(item: IPayerAddressItem) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
    const url: string =
      baseurl +
      '/Payer/delete_payeraddress' +
      '?payeraddressid=' +
      item.payerAddressId +
      '&userid=' +
      userid;

    await axios.get(tokenurl).then(async res => {
      if (res.data.success) {
        await axios
          .delete(url, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              toast({
                title: 'Success',
                description: item.payerName + ' deleted successfully',
                position: 'top',
                status: 'success',
                duration: 10000,
                isClosable: true,
              });
              onDeleteModalClose();
              dispatch(fetchPayerAddressList());
            }
          })
          .catch(error => {
            toast({
              title: 'Error!',
              description:
                error.response.data.message != ''
                  ? error.response.data.message
                  : error.message,
              position: 'top',
              status: 'error',
              duration: 4000,
              isClosable: true,
            });
            onDeleteModalClose();
          });
      }
    });
    setDeleteOkLoading(false);
  }

  function openModal(id: number) {
    var data = PayerAddressList.find(item => item.payerAddressId == id);

    let payerMasterId: number = data?.payerMasterId!;
    let payerName: string = data?.payerName!;
    let payerId: string = data?.payerId!;
    let address: string = data?.address!;
    let city: string = data?.city!;
    let state: string = data?.state!;
    let zip: string = data?.zip!;
    let phoneNo: string = data?.phoneNo!;
    let faxNo: string = data?.faxNo!;
    let isActive: boolean = data?.isActive!;
    let createdOn: string = data?.createdOn!;
    let createdBy: string = data?.createdBy!;
    let modifiedBy: string = data?.modifiedBy!;
    let modifiedOn: string = data?.modifiedOn!;

    const item: IPayerAddressItem = {
      payerAddressId: id,
      payerMasterId: payerMasterId,
      payerName: payerName,
      payerId: payerId,
      address: address,
      city: city,
      state: state,
      zip: zip,
      phoneNo: phoneNo,
      faxNo: faxNo,
      isActive: isActive,
      createdOn: createdOn,
      createdBy: createdBy,
      modifiedBy: modifiedBy,
      modifiedOn: modifiedOn,
    };
    dispatch(setPayerAddressItem(item));
    onOpen();
  }

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = PayerAddressList.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IPayerAddressItem])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-end" paddingBottom=".5rem">
          <Button
            bg="#002677"
            color="white"
            variant="outline"
            size="md"
            leftIcon={<FaMapSigns />}
            mr={4}
            onClick={() => openModal(0)}
          >
            Add New Payer Address
          </Button>
          <Input
            htmlSize={24}
            width="auto"
            className="form-control"
            type="text"
            placeholder="Search table..."
            onChange={filterData}
            style={{ float: 'right', marginRight: '0.5rem' }}
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white">PAYER NAME</Th>
                <Th color="white">ADDRESS</Th>
                <Th color="white">CITY</Th>
                <Th color="white">STATE</Th>
                <Th color="white">ZIP</Th>
                <Th color="white">ACTIVE</Th>
                {userrole.toUpperCase() != 'USER' && (
                  <Th color="white">
                    ACTIONS
                  </Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {(value.length > 0 ? TableFilter : PayerAddressList)
                .slice(firstIndex, lastIndex)
                .map(payernameaddress => {
                  return (
                    <Tr
                      key={payernameaddress.payerAddressId}
                      style={{ fontSize: '10px' }}
                    >
                      <Td maxWidth={200} whiteSpace="pre">
                        {payernameaddress.payerName}
                      </Td>
                      <Td whiteSpace="pre">{payernameaddress.address}</Td>
                      <Td whiteSpace="pre">{payernameaddress.city}</Td>
                      <Td whiteSpace="pre">{payernameaddress.state}</Td>
                      <Td whiteSpace="pre">{payernameaddress.zip}</Td>
                      <Td>
                        {payernameaddress.isActive == true ? 'True' : 'False'}
                      </Td>
                      {userrole.toUpperCase() != 'USER' && (
                        <Td pt="0" pb="0" mt="0" mb="0">
                          <Tooltip hasArrow label="Edit" placement="left">
                            <IconButton
                              size="xs"
                              aria-label="edit"
                              icon={<BsPencilSquare />}
                              onClick={e =>
                                openModal(payernameaddress.payerAddressId)
                              }
                            />
                          </Tooltip>
                          <Tooltip
                            hasArrow
                            label="Delete Item"
                            bg="gray.300"
                            color="black"
                          >
                            <IconButton
                              size="xs"
                              ml={4}
                              aria-label="Delete"
                              icon={<ImBin />}
                              onClick={() => deleteItemDialog(payernameaddress)}
                            />
                          </Tooltip>
                        </Td>
                      )}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <PayerAddressModalPopup
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteModalClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Payer Address?
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              Are you sure you want to delete Payer address of{' '}
              <b>{toBeDeletedItem?.payerName}</b> ?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteModalClose}
                ml={3}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={() => deleteItem(toBeDeletedItem!)}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default PayerAddressPg;
